var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterMobileArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8835 0.366227C10.6491 0.131889 10.3312 0.000244141 9.99972 0.000244141C9.66826 0.000244141 9.35038 0.131889 9.11597 0.366227L0.365967 9.11623C0.131628 9.35064 -1.52588e-05 9.66852 -1.52588e-05 9.99998C-1.52588e-05 10.3314 0.131628 10.6493 0.365967 10.8837L9.11597 19.6337C9.35172 19.8614 9.66747 19.9874 9.99522 19.9846C10.323 19.9817 10.6365 19.8503 10.8682 19.6185C11.1 19.3867 11.2315 19.0732 11.2343 18.7455C11.2372 18.4177 11.1112 18.102 10.8835 17.8662L3.01722 9.99998L10.8835 2.13373C11.1178 1.89932 11.2495 1.58143 11.2495 1.24998C11.2495 0.918522 11.1178 0.600637 10.8835 0.366227Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterMobileArrowLeft);
export default __webpack_public_path__ + "static/media/CenterMobile-arrowLeft.5c697c1f08100a423dc25b25196a6043.svg";
export { ForwardRef as ReactComponent };